import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    .hero-slider-area {
        .swiper-container {
            position: relative;

            .swiper-wrapper {
                .swiper-slide.slider-item {
                    position: relative;

                    .image-container {
                        width   : 100%;
                        display: flex;
                        justify-content: center; 
                        align-items: center;
                        overflow: hidden;
                        position: relative;
                        height  : 700px;

                        img.slider-image {
                            min-width: 100%;   
                            min-height: 100%; 
                            object-fit: cover; 
                            transition: all 6000ms linear;
                            transform: scale(1);
                        }

                        @media(max-width: 767px) {
                            height  : 450px;
                        }

                        @media(max-width: 575px) {
                            height  : 360px;
                        }
                    }

                    .slider-table {
                        display : table;
                        width   : 100%;
                        height  : 100%;
                        position: absolute;
                        top     : 0;
                        left    : 0;
                        z-index : 9999;

                        .slider-tablecell {
                            display       : table-cell;
                            vertical-align: middle;

                            .slider-box {
                                .slider-title {
                                    p {
                                        font-size     : 18px;
                                        // color         : ${colors.border3};
                                        text-transform: uppercase;
                                        margin-bottom : 8px;
                                    }
                                }

                                .slider-desc {
                                        margin-bottom: 32px;
                                    h1 {
                                        font-size    : 46px;
                                        // color     : #ffffff;
                                        max-width    : 700px;
                                        font-weight  : 600;

                                        @media(max-width: 767px) {
                                            font-size    : 26px;
                                            font-weight  : 500;
                                        }
                                    }
                                }

                                .slider-btn {
                                    
                                    a.slider-btn1 {
                                        font-size : 14px;
                                        color     : #fff;
                                        background: ${colors.gr_bg};
                                        display   : inline-block;
                                        width     : 145px;
                                        height    : 40px;
                                        text-align: center;
                                        padding   : 11px;
                                        border-radius : 5px;
                                        opacity   : 1 !important;
                                        transition: background 0.3s ease;
                                        outline   : none !important;
                                        box-shadow: none !important;
                                        border    : none;
                                        cursor    : pointer;

                                        &:hover {
                                            background: ${colors.gr_bg2};
                                            opacity   : 1 !important;
                                        }

                                        &:active {
                                            background: ${colors.gr_bg2};
                                            opacity   : 1 !important;
                                        }

                                        &:focus {
                                            outline   : none !important;
                                            box-shadow: none !important;
                                            background: ${colors.gr_bg};
                                            opacity   : 1 !important;
                                        }

                                        &:visited {
                                            opacity   : 1 !important;
                                        }
                                    }

                                    a.slider-btn2 {
                                        font-size : 14px;
                                        color     : #fff;
                                        background: ${colors.bg1};
                                        display   : inline-block;
                                        width     : 145px;
                                        height    : 40px;
                                        text-align: center;
                                        padding   : 11px ;
                                        border-radius : 5px;
                                        margin-left: 15px;
                                        opacity   : 1 !important;
                                        transition: background 0.3s ease;
                                        outline   : none !important;
                                        box-shadow: none !important;
                                        border    : none;
                                        cursor    : pointer;

                                        &:hover {
                                            background: ${colors.bg3};
                                            opacity   : 1 !important;
                                        }

                                        &:active {
                                            background: ${colors.bg3};
                                            opacity   : 1 !important;
                                        }

                                        &:focus {
                                            outline   : none !important;
                                            box-shadow: none !important;
                                            background: ${colors.bg1};
                                            opacity   : 1 !important;
                                        }

                                        &:visited {
                                            opacity   : 1 !important;
                                        }
                                    }
                                }

                                @media(max-width: 575px) {
                                    text-align  : center !important;
                                }
                            }

                            .slider-box2 {
                                .slider-desc {
                                    h1 {
                                        margin-left: auto;
                                    }
                                }
                            }
                        }
                    }
                }

                .swiper-slide.slider-item.swiper-slide-visible.swiper-slide-active {
                    .image-container {
                        img.slider-image {
                            transform: scale(1.15);
                        }
                    }

                    .slider-table {
                        .slider-tablecell {
                            .slider-title {
                                animation-name     : fadeInDown;
                                animation-duration : 1s;
                                animation-delay    : 0.2s;
                                animation-fill-mode: both;
                            }

                            .slider-desc {
                                animation-name     : fadeInUp;
                                animation-duration : 1.5s;
                                animation-delay    : 0.2s;
                                animation-fill-mode: both;
                            }

                            .slider-btn {
                                animation-name     : fadeInUp;
                                animation-duration : 2s;
                                animation-delay    : 0.2s;
                                animation-fill-mode: both;
                            }
                        }
                    }
                }
            }

            .swiper-btn {
                position   : absolute;
                top        : 50%;
                left       : 40px;
                width      : 45px;
                height     : 45px;
                font-size  : 24px;
                color      : ${colors.border1};
                text-align : center;
                padding-top: 5px;
                border-radius : 5px;
                transition : all 0.3s ease;
                margin-top: -35px;
                z-index   : 111;

                i {}

                &:hover {
                    background: ${colors.gr_bg};
                    color     : #ffffff;
                }

                @media(max-width: 575px) {
                    display:none;
                }
            }

            .swiper-btn.slider-button-next {
                left : inherit;
                right: 40px;
            }
        }
    }
`;